import template from './sidenav.html';

class SidenavController {
  /** @ngInject */
  constructor(
    $rootScope, $state, $mdSidenav,
    $log, MenuItemService
  ) {
    this.$mdSidenav = $mdSidenav;
    this.menuItemService = MenuItemService;
    this.$log = $log;
    this.$state = $state;
    this.$rootScope = $rootScope;

    this.items = [];
    // Attach includes function to controller
    this.isActive = this.$state.includes;
    this.currentNavItem = this.$state.current.name;

    this.$rootScope.$on('state.dashboard', () => {
      this.currentNavItem = 'modules.dashboard';
    });
  }

  $onInit() {
    this.menuItemService.getItems().then(items => {
      this.items = items;
    });
  }
}

export const Sidenav = {
  template,
  controller: SidenavController
};
